import { render, staticRenderFns } from "./EditCriteria.vue?vue&type=template&id=ab57ae56&scoped=true&"
import script from "./EditCriteria.vue?vue&type=script&lang=js&"
export * from "./EditCriteria.vue?vue&type=script&lang=js&"
import style0 from "./EditCriteria.vue?vue&type=style&index=0&id=ab57ae56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab57ae56",
  null
  
)

export default component.exports